var map = {
	"./images/student-snapshort2-comment.png": 276,
	"./images/student-snapshort2-feild.png": 277,
	"./images/student-snapshort2-frame.png": 278,
	"./images/student-snapshort2-gameplay.png": 279,
	"./images/student-snapshort2-level.png": 280,
	"./images/student-snapshort2-line.png": 281,
	"./images/student-snapshort2-name.png": 282,
	"./images/student-snapshort2-photo.png": 283,
	"./images/student-snapshort2-ploblem.png": 284,
	"./images/student-snapshort2-point.png": 285,
	"./images/student-snapshort2-score.png": 286,
	"./images/student-snapshort2-side.png": 287,
	"./images/student-snapshort2-study.png": 288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 275;